<template>

  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'CategoryGroupList' }">Category Groups</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
      ref="category_group"
      :rules="rules.category_group"
      :model="category_group"
      :label-position="label_position">

      <el-form-item label="Name:" prop="name">
        <el-input v-model="category_group.name"></el-input>
      </el-form-item>

      <el-form-item label="Sort Order:" prop="sort_order">
        <el-input-number controls-position="right" :min="0" v-model="category_group.sort_order"></el-input-number>
      </el-form-item>

      <el-form-item label="Thumbnail Upload:">
        <el-upload
          class="upload"
          ref="upload"
          :action="uploadEndpoint"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :multiple="false"
          :limit="1"
          :auto-upload="false"
          :data="category_group"
          :on-success="uploadSuccess"
          list-type="picture">
          <el-button slot="trigger" type="primary">Select File</el-button>
          <el-button style="margin-left: 10px;" type="success" @click="submitUpload">Add Category Group</el-button>
        </el-upload>     
      </el-form-item>		

    </el-form>

    <pre v-if="config.debug">{{$data}}</pre>

  </div>

</template>

<style>

</style>

<script>

  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';

  export default {
    data: function() {
      return {
        page_alias: 'Edit Product Category Group',
        page_slug: 'add-product-category-group',
        label_position: 'top',

        config: Config.config,
        
        category_group: {
          id: '',
          name: '',
          thumbnail_url: '',
          sort_order: '',
        },

        fileList: [],

        rules: {
          category_group: {
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],
            sort_order: [
              { required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
            ]
          }
        } 
      }
    },

    computed: {
      uploadEndpoint: function() {
        const me = this;
        return me.config.api + 'category-group';
      }
    },

    methods: {
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },

      handlePreview(file) {
        console.log(file);
      },

      submitUpload: function () {
        console.log('Submit Upload Function');
        const me = this;
        me.$refs.upload.submit();
      },

      uploadSuccess: function() {
        const me = this;
        
        me.$notify({
          title: 'Success',
          message: 'Category Group Added',
          type: 'success'
        }); 

        me.$router.push({ name: 'CategoryGroupList' });

      },
    }//END METHODS
  }
</script>


// WEBPACK FOOTER //
// src/pages/product-category-groups/CategoryGroupAdd.vue